export default {
    DAILY: 0,
    WEEKLY: 1,
    MONTHLY: 2,
}